module.exports = __webpack_public_path__ + "static/media/Asset 1.b19ca5fe.svg";